import i18n from 'i18next';
import isEmpty from 'lodash/isEmpty';

import { NS } from 'shared/constants/translation/nameSpace';
import { setDateFnsLocale } from 'shared/utils/date';

import type { ResourceKey } from 'i18next';

export const updateResources = async (
  locale: string,
  resources: ResourceKey,
) => {
  if (i18n.isInitialized && !isEmpty(resources) && i18n.language !== locale) {
    i18n.addResources(locale, NS, resources);

    await setDateFnsLocale(locale);
    await i18n.changeLanguage(locale);
  }
};
